<div class="container">

    <p class="txt_nome_escola">{{ nome_escola }}</p>

    <app-stepper [recebeAba]="aba"></app-stepper>

    <div *ngIf="isLoading" class="loading">
        <mat-spinner></mat-spinner>
    </div>

    <mat-card class="card" *ngIf="!isLoading">
        <mat-card-content>

            <table mat-table class="table" [dataSource]="dataSource">
                <ng-container matColumnDef="nome_dependente">
                    <th mat-header-cell *matHeaderCellDef>Nome</th>
                    <td mat-cell *matCellDef="let row">{{ row.nome_dependente }}</td>
                    <td mat-footer-cell *matFooterCellDef> Total do carrinho</td>
                </ng-container>
                <ng-container matColumnDef="valor">
                    <th mat-header-cell *matHeaderCellDef>
                        Valor
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.total | currency:'BRL':'symbol':'1.2-2'}}</td>
                    <td mat-footer-cell *matFooterCellDef>
                        {{ total | currency:'BRL':'symbol':'1.2-2'}}
                        <!-- Exibe o valor do dependente atual -->
                        <!-- {{ totalPorDependente[serie.nome_dependente] | currency:'BRL':'symbol':'1.2-2' }} -->
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
            </table>

            <mat-divider class="mat-divider-margin"></mat-divider>

            <div>
                <p class="txt_frete"><strong>Frete:</strong> {{ frete == 0 ? 'Grátis' : (frete | currency:'BRL':'symbol':'1.2-2')}}</p>
                <mat-divider></mat-divider>
                <p class="txt_frete"><strong>Total do carrinho + Frete:</strong> <strong>{{ (frete + total) | currency:'BRL':'symbol':'1.2-2'}}</strong></p>
            </div>

            <mat-divider class="mat-divider-margin"></mat-divider>

            <div *ngIf="this.id_form_envio == 1">
                <p class="p_checkbox">
                    <mat-checkbox [checked]="'true'" [disabled]="true"></mat-checkbox>
                    <span><strong>Os materiais serão entregues no endereço da escola:</strong> {{endereco}}</span>
                </p>
            </div>


            <div *ngIf="this.id_form_envio == 2">
                <p class="p_checkbox">
                    <span>Form</span>
                </p>
            </div>

        </mat-card-content>

        <mat-card-actions>
            <button mat-button type="button" [routerLink]="'/lista-material'"><mat-icon class="mat-18">arrow_back</mat-icon>VOLTAR</button>
            <button mat-raised-button color="primary" (click)="continuar()" *ngIf="exibeBotaoContinuar()">CONTINUAR</button>
        </mat-card-actions>
    </mat-card>
</div>